import { usePageTitle } from '@global-dax-ad-platform/dax-hooks';
import { Container, Divider } from '@global-engineering-shared/gweb-material-ui';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import DraftErrorsCard from 'components/DraftErrorsCard';
import LoadableComponent from 'components/LoadableComponent';
import { initialDraftEntityResponseState } from 'features/Drafts/pages/DraftDetailsPage/utils/initialDraftDetailsState';
import { getEntityTitle } from 'features/Entity/components/EntityActionBar/utils/getEntityTitle';
import EntityDetailsBody from 'features/EntityDetails/components/EntityDetails/EntityDetailsBody';
import EntityDetailsHeader from 'features/EntityDetails/components/EntityDetails/EntityDetailsHeader';
import LinkedFramesDetailTableContainer from 'features/EntityDetails/components/EntityDetails/LinkedFramesDetailTable/components/LinkedFramesDetailTableContainer';
import useFetchData from 'hooks/useFetchData';
import { IDraftEntityResponse, isLinkedAsset } from 'types/detailsEntityType';
import { DEFAULT_TITLE, DRAFTS_API_URL, DRAFTS_PAGE_URL } from 'utils/defaults';
import { isStatusError } from 'utils/statuses';

type DraftParams = {
  draftEntityId: string;
};

const DraftDetailsPage = () => {
  const { draftEntityId } = useParams<DraftParams>();
  const { getData, isDataLoading } = useFetchData();
  const [draftEntity, setDraftEntity] = useState<IDraftEntityResponse>(
    initialDraftEntityResponseState
  );

  useEffect(() => {
    if (draftEntityId) {
      const retrieveDraftEntity = async () => {
        const url = `${DRAFTS_API_URL}/${draftEntityId}`;
        await getData<IDraftEntityResponse>(url, (response) => {
          setDraftEntity(response);
        });
      };

      retrieveDraftEntity();
    }
  }, [draftEntityId]);

  usePageTitle(DEFAULT_TITLE, `Draft ${draftEntityId}`);

  return (
    <main>
      <LoadableComponent loading={isDataLoading}>
        <Container maxWidth="lg">
          <EntityDetailsHeader
            entity={draftEntity.draft}
            previousEntity={draftEntity.previous}
            backLink={DRAFTS_PAGE_URL}
            linkLabel="Drafts"
            entityLabel={getEntityTitle(draftEntity.previous?.entityType)}
          />
          {isStatusError(draftEntity.draft.status, draftEntity.draft.draftErrors?.length) && (
            //TODO update this when shared component is exported
            <DraftErrorsCard errors={draftEntity.draft.draftErrors} />
          )}
          <EntityDetailsBody
            entity={draftEntity.draft}
            previousEntity={draftEntity.previous}
            otherComponents={
              <>
                {isLinkedAsset(draftEntity.draft) && (
                  <>
                    <Divider data-testid="divider" />
                    <LinkedFramesDetailTableContainer
                      data={draftEntity.draft.linkedAssetFrames}
                      previousData={
                        draftEntity.previous && isLinkedAsset(draftEntity.previous)
                          ? draftEntity.previous.linkedAssetFrames
                          : undefined
                      }
                    />
                  </>
                )}
              </>
            }
          />
        </Container>
      </LoadableComponent>
    </main>
  );
};

export default DraftDetailsPage;
